import React, { useState } from 'react';
import { PillarData } from '../../lib/pillarTypes';
import styles from './ProjectDetail.module.css';

export interface CommunityTabPanelProps {
  data: PillarData;
}

/* Placeholder thread data */
const SAMPLE_THREADS = [
  {
    author: 'Jordan M.',
    date: 'Mar 2, 2026',
    text: 'Has anyone tested the new drip irrigation system on clay soils? We had mixed results last season.',
    replies: 4,
  },
  {
    author: 'Nina S.',
    date: 'Feb 27, 2026',
    text: 'The volunteer training session last Saturday was excellent. Notes and slides are posted in the Expert tab.',
    replies: 2,
  },
  {
    author: 'Community Bot',
    date: 'Feb 25, 2026',
    text: 'Schedule progress updated: 62% complete. Next milestone: Phase 3 site prep (due March 15).',
    replies: 0,
  },
];

const SAMPLE_UPDATES = [
  { text: 'Budget review completed — all categories on track.', when: '2 hours ago' },
  { text: 'New volunteer signup: 8 participants joined this week.', when: '1 day ago' },
  { text: 'Photo gallery updated with 12 new site images.', when: '3 days ago' },
  { text: 'Mission metric "trees planted" updated: 1,247 of 2,000.', when: '5 days ago' },
];

export default function CommunityTabPanel({ data }: CommunityTabPanelProps) {
  const [view, setView] = useState<'discussion' | 'updates'>('discussion');

  return (
    <div className={styles.panel}>
      {/* Toggle: Discussion / Updates */}
      <div className={styles.toggleRow}>
        <button
          className={`${styles.toggleBtn} ${view === 'discussion' ? styles.active : ''}`}
          onClick={() => setView('discussion')}
        >
          Discussion
        </button>
        <button
          className={`${styles.toggleBtn} ${view === 'updates' ? styles.active : ''}`}
          onClick={() => setView('updates')}
        >
          Updates
        </button>
      </div>

      {view === 'discussion' && (
        <div className={styles.cardList}>
          {SAMPLE_THREADS.map((t, i) => (
            <div key={i} className={styles.articleCard}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <span style={{ fontWeight: 600, fontSize: 14 }}>{t.author}</span>
                <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{t.date}</span>
              </div>
              <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5, margin: 0 }}>{t.text}</p>
              {t.replies > 0 && (
                <span style={{ fontSize: 12, color: 'var(--accent-primary)' }}>{t.replies} replies</span>
              )}
            </div>
          ))}

          <div className={styles.placeholder} style={{ marginTop: 12 }}>
            <div className={styles.placeholderIcon}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="1.5">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </div>
            <h4 className={styles.placeholderTitle}>Start a Discussion</h4>
            <p className={styles.placeholderText}>
              Community members can ask questions, share ideas, and dialogue about this project.
            </p>
          </div>
        </div>
      )}

      {view === 'updates' && (
        <div className={styles.widgetBody}>
          {SAMPLE_UPDATES.map((u, i) => (
            <div key={i} className={styles.activityItem}>
              <span className={styles.activityDot} />
              <div>
                <div style={{ fontSize: 13 }}>{u.text}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{u.when}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
